import { Component, Input, OnInit, Output, ViewChild, EventEmitter, SimpleChange, ElementRef } from '@angular/core';
import { DxDrawerComponent } from 'devextreme-angular';
import { List, ServiceTaskAction } from "./task-action-services";




@Component({
  selector: 'app-task-action',
  templateUrl: './task-action.component.html',
  styleUrls: ['./task-action.component.css'],
  providers: [ServiceTaskAction],
})

export class TaskActionComponent implements OnInit {
  @ViewChild('content_draw', { static: false }) public mydiv: ElementRef;
  @Input() isDrawerOpen:boolean=false;
  @Output() onRowSelect=new EventEmitter() ;
  @Output() isDrawerOpenChange: EventEmitter<boolean> = new EventEmitter<boolean>();

 // @ViewChild(DxDrawerComponent, { static: false }) drawer: DxDrawerComponent;

  navigation: List[] ;

  showSubmenuModes: string[] = ['slide', 'expand'];
  positionModes: string[] = ['left', 'right'];
  showModes: string[] = ['push', 'shrink', 'overlap'];
  text: string;
  selectedOpenMode: string = 'overlap';
  selectedPosition: string = 'right';
  selectedRevealMode: string = 'slide';
  //isDrawerOpen: Boolean = true;
  elementAttr: any;

  constructor(service: ServiceTaskAction) {
    this.navigation = service.getNavigationList();
   }

out(){
  this.isDrawerOpen=false;
  this.isDrawerOpenChange.emit(false)
  //this.mydiv.nativeElement.visible=false;

}
hoclikkato(e){
  console.log(e);
  this.onRowSelect.next(e.itemIndex);
  //this.isDrawerOpen=false;
  //alert( e.itemIndex+ " ma tu da me che cosa vuoi?");
}

  ngOnInit() {
  }

  ngOnChanges(simple:SimpleChange){
   // this.mydiv.nativeElement.visible=this.isDrawerOpen;
    console.log('pippo',simple);

  }
}
